module.exports = __webpack_public_path__ + "media/images/logo-278e542c3528f5dc3a72e0f426167ccb.png";